// Code generated by tools/scripts/generate-agent-gui-provider-catalog.mjs. DO NOT EDIT.

export const AGENT_CAPABILITY_KEYS = [
  "imageInput",
  "modelImageInputRequired",
  "modelSwitch",
  "modelPlanBinding",
  "skills",
  "compact",
  "tokenUsage",
  "rateLimits",
  "planMode",
  "interrupt",
  "activeTurnGuidance",
  "browserUse",
  "computerUse",
  "goalPause",
  "planImplementation",
  "permissionModeChangeDuringTurn",
  "permissionModeChangeDeferred",
  "review",
  "resumeRunningTurn"
] as const;
export type AgentCapabilityKey = (typeof AGENT_CAPABILITY_KEYS)[number];
